<template>
  <v-card max-width="800" style="height: 100%" class="mx-auto">
    <v-app-bar dark style="color: #bc4749" color="#ffffff">
      <v-btn icon>
        <v-icon style="color: #bc4749">mdi-presentation</v-icon>
      </v-btn>

      <v-toolbar-title style="text-transform: uppercase"
        ><b>{{ vName }}</b></v-toolbar-title
      >

      <v-spacer></v-spacer>
      <v-btn @click="saveFavorite()" icon>
        <v-icon
          v-if="isFavorite"
          style="color: red; padding-right: 2rem"
          x-large
          >mdi-heart</v-icon
        >
        <v-icon v-else style="color: gray; padding-right: 2rem" x-large
          >mdi-heart</v-icon
        >
      </v-btn>
      <v-btn @click="saveComplete()" icon>
        <v-icon
          v-if="isCompleted"
          style="color: green; padding-right: 2rem"
          x-large
          >mdi-checkbox-marked-circle</v-icon
        >
        <v-icon v-else style="color: gray; padding-right: 2rem" x-large
          >mdi-checkbox-marked-circle</v-icon
        >
      </v-btn>
      <v-btn v-if="userRole == 'admin'" @click="recommedClase()" icon>
        <v-icon
          v-if="isRecommended"
          style="color: gold; padding-right: 2rem"
          x-large
          >mdi-star</v-icon
        >
        <v-icon v-else style="color: gray; padding-right: 2rem" x-large
          >mdi-star</v-icon
        >
      </v-btn>
    </v-app-bar>

    <v-container>
      <v-row dense>
        <v-col cols="12">
          <v-card color="#386641" style="min-height: 15rem" dark>
            <v-card-title class="headline"> <b>Descripción</b> </v-card-title>
            <div class="simpleText">{{ vDescription }}</div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
import { db } from "@/main";
import * as faker from "faker";

export default {
  data() {
    return {
      isFavorite: null,
      isCompleted: null,
      idDocumentVideo: null,
      idDocumentVideoComp: null,
      isRecommended: null
    };
  },
  props: {
    vName: String,
    vDescription: String
  },
  computed: {
    ...mapState({
      userID: (state) => state.authModule.user.uid,
      userRole: (state) => state.authModule.role,
      videoIdFromFirebase: (state) => state.videoIdFromFirebase,
    }),
  },
  methods: {
    async saveFavorite() {
      let myVideo = this.$route.params.id;
      if (this.isFavorite != true) {
        const dataVideo = {
          video_id: myVideo,
        };        
        let docId = faker.random.alphaNumeric(10)
        await db
          .collection("users")
          .doc(this.userID)
          .collection("my_favorites")
          .doc(docId)
          .set(dataVideo)
          .then(() => {
            this.isFavorite = true;
            this.idDocumentVideo = docId
          });
      } else {
        db.collection("users")
          .doc(this.userID)
          .collection("my_favorites")
          .doc(this.idDocumentVideo)
          .delete()
          .then(() => {
            this.isFavorite = false;
          });
      }
    },
    async saveComplete() {
      let myVideo = this.$route.params.id;
      if (this.isCompleted != true) {
        const dataVideo = {
          video_id: myVideo,
        };        
        let docId = faker.random.alphaNumeric(10)
        await db
          .collection("users")
          .doc(this.userID)
          .collection("videos_completed")
          .doc(docId)
          .set(dataVideo)
          .then(() => {
            this.isCompleted = true;
            this.idDocumentVideoComp = docId
          });
      } else {
        db.collection("users")
          .doc(this.userID)
          .collection("videos_completed")
          .doc(this.idDocumentVideoComp)
          .delete()
          .then(() => {
            this.isCompleted = false;
          });
      }
    },
    async recommedClase() {
      let myVideo = this.$route.params.id;
      if (this.isRecommended != true) {
        const dataVideo = {
          video_id: myVideo,
        };        
        let docId = faker.random.alphaNumeric(10)
        await db
          .collection("recommend")
          .doc(docId)
          .set(dataVideo)
          .then(() => {
            this.isRecommended = true;
            this.idDocumentVideoComp = docId
          });
      } else {
        db.collection("recommend")
          .where("video_id", "==", myVideo)
          .get()
          .then(async (idRecommended) => {
            db.collection("recommend")
            .doc(idRecommended.docs[0].id)
            .delete()
            .then(() => {
              this.isRecommended = false;
            })
          });
      }
    }
  },
  async mounted() {
    this.isFavorite = null;
    this.isCompleted = null;
    let myVideo = this.$route.params.id;
    try {	
    await db
      .collection("users")
      .doc(this.userID)
      .collection("my_favorites")
      .where("video_id", "==", myVideo)
      .get()
      .then(async (fav) => {
        if (!fav.empty) this.isFavorite = true;
        this.idDocumentVideo = fav.docs[0].id
      });
    } catch(e) {
      console.error(e)
    }
    try {
      await db
      .collection("users")
      .doc(this.userID)
      .collection("videos_completed")
      .where("video_id", "==", myVideo)
      .get()
      .then(async (fav) => {
        if (!fav.empty) this.isCompleted = true;
        this.idDocumentVideoComp = fav.docs[0].id
      });
    } catch(e) {
      console.error(e)
    }  
    try {
      await db
      .collection("recommend")      
      .where("video_id", "==", myVideo)
      .get()
      .then(async (fav) => {
        if (!fav.empty) this.isRecommended = true;
        this.idDocumentVideoComp = fav.docs[0].id
      });
    } catch(e) {
      console.error(e)
    }  
    
  },
  
};
</script>
<style scoped>
.simpleText {
  text-align: left;
  padding: 0.5rem 2rem;
  font-size: 1.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/video_components/description.vue